export const executiveFilters = {
  states: ['Todos', 'PR', 'SC', 'RS'],
  cultures: ['Todas', 'Soja', 'Milho', 'Trigo'],
  technicians: ['Todos', 'Marina Costa', 'Joao Becker', 'Lucas Bianchi', 'Ana Rosa'],
  periods: ['Ultimos 30 dias', 'Ultimos 90 dias', 'Safra Atual'],
}

export const regionalRecords = [
  {
    state: 'PR',
    culture: 'Soja',
    technician: 'Marina Costa',
    receitas: 420,
    produtores: 156,
    cultivares: 18,
    tecnicosAtivos: 12,
    hectares: 38400,
  },
  {
    state: 'SC',
    culture: 'Milho',
    technician: 'Joao Becker',
    receitas: 268,
    produtores: 98,
    cultivares: 11,
    tecnicosAtivos: 8,
    hectares: 21700,
  },
  {
    state: 'RS',
    culture: 'Trigo',
    technician: 'Lucas Bianchi',
    receitas: 351,
    produtores: 127,
    cultivares: 14,
    tecnicosAtivos: 9,
    hectares: 29600,
  },
  {
    state: 'PR',
    culture: 'Milho',
    technician: 'Ana Rosa',
    receitas: 189,
    produtores: 73,
    cultivares: 8,
    tecnicosAtivos: 6,
    hectares: 15200,
  },
  {
    state: 'RS',
    culture: 'Soja',
    technician: 'Marina Costa',
    receitas: 214,
    produtores: 84,
    cultivares: 9,
    tecnicosAtivos: 7,
    hectares: 16800,
  },
]

export const kpiBaseline = {
  receitasMesAnterior: 1320,
  produtoresAtivosAnterior: 486,
  tecnicosAtivosAnterior: 34,
  hectaresAssistidosAnterior: 113500,
  crescimentoRegionalAnterior: 9.1,
}

export const cultivarPerformance = [
  { name: 'Soja', receitas: 779, growth: 11.3 },
  { name: 'Milho', receitas: 294, growth: -3.2 },
  { name: 'Trigo', receitas: 238, growth: 6.1 },
]

export const receitasPorEstado6Meses = {
  categories: ['Set', 'Out', 'Nov', 'Dez', 'Jan', 'Fev'],
  series: [
    { name: 'PR', data: [210, 228, 245, 251, 270, 289] },
    { name: 'SC', data: [142, 153, 168, 174, 181, 193] },
    { name: 'RS', data: [180, 192, 205, 218, 230, 244] },
  ],
}

export const safraInsights = [
  {
    level: 'positive',
    title: 'Conversao Campo para Venda',
    message:
      'Talhoes com assistencia tecnica completa apresentaram 22% mais volume de sementes comercializadas.',
    source: 'Base interna WebReceita',
  },
  {
    level: 'info',
    title: 'Mix de Cultivares',
    message:
      'Soja e milho concentram 81% das receitas emitidas, indicando oportunidade de ampliar trigo na proxima janela.',
    source: 'Base interna WebReceita',
  },
  {
    level: 'warning',
    title: 'Risco de Janela de Plantio',
    message:
      '14% das recomendacoes de sementes no Sul foram emitidas fora da faixa ideal de plantio; revisar planejamento comercial.',
    source: 'Base interna WebReceita',
  },
]

export const technicalIndicators = {
  emissaoPorVisita: {
    value: '78,4%',
    trend: 6.3,
    spark: [58, 60, 63, 67, 72, 78],
  },
  retorno30Dias: {
    value: '64,1%',
    trend: 4.7,
    spark: [48, 51, 53, 56, 60, 64],
  },
  tempoMedioVisitaEmissao: {
    value: '1,8 dia',
    trend: -12.6,
    spark: [2.6, 2.4, 2.3, 2.1, 2, 1.8],
  },
  taxaCancelamento: {
    value: '2,4%',
    trend: -0.8,
    spark: [5, 4.2, 4, 3.5, 3, 2.4],
  },
  produtosMaisRecomendados: [
    { name: 'Fungicida Triazol X', share: 26 },
    { name: 'Inoculante BioSeed', share: 19 },
    { name: 'Trat. Semente Shield', share: 17 },
    { name: 'Herbicida Select Pro', share: 13 },
  ],
}
